<template>
  <div class="contentHome">
    <div class="centerPage">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
        <el-breadcrumb-item>
          <a href="/news" class="aHref">新闻资讯</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>资讯详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="infoCon">
        <div class="contentHeight">
          <div class="page-content">
            <div class="left-body">

              <h3>{{ details.title }}</h3>
              <p class="readingTime">
                <span>发布时间：{{ details.publishDate }}</span>
                <span>发布人：{{ name }}</span>
                <span>{{ details.viewsCount }}阅读</span>
              </p>

              <div v-if="details.thumbnailPath"
                   :style="'background: url('+details.thumbnailPath+') no-repeat;height: 330px;backgroundSize: 80%;backgroundPosition: center;'"></div>
              <div class="narrate ban-cp" v-html="details.pageContent" style="white-space: pre-line"></div>
<!--              <span v-show="needLogin" @click="showLoginDialog" class="checkAll">登录/注册查看全部文章</span>-->
            </div>

            <div class="right-side">
              <h4>本周推荐</h4>
              <div v-for="(item,index) in weekHotList" :key="item.id" class="list" @click="toDetails(item.id)">
                <span>{{ index + 1 }}</span>
                <p>{{ item.title }}</p>
              </div>
            </div>
          </div>

        </div>
        <div class="flex artFoot">
          <div class="share flex">
            <span>分享：</span>
            <el-popover popper-class="popoverText"
                        placement="top"
                        width="100"
                        trigger="hover">
              <div class="shareImg" slot="reference">
                <img src="../../assets/img/wx_a.png" alt="" class="block">
                <img src="../../assets/img/wx_b.png" alt="" class="none">
              </div>
              <div class="txt">
                <div id="wechat-share-qr" style="width: 80px;height: 80px"></div>
                <p>微信扫一扫<br>分享至朋友圈</p>
              </div>
            </el-popover>
            <el-popover popper-class="popoverText"
                        placement="top"
                        width="100"
                        trigger="hover">
              <div class="shareImg" slot="reference">
                <img src="../../assets/img/qq_a.png" alt="" class="block">
                <img src="../../assets/img/qq_b.png" @click="share('qq')" alt="" class="none">
              </div>
              <div class="txt">
                <p>分享至QQ空间</p>
              </div>
            </el-popover>
            <el-popover popper-class="popoverText"
                        placement="top"
                        width="100"
                        trigger="hover">
              <div class="shareImg" slot="reference">
                <img src="../../assets/img/wb_a.png" alt="" class="block">
                <img src="../../assets/img/wb_b.png" @click="share('wb')" alt="" class="none">
              </div>
              <div class="txt">
                <p>分享至新浪微博</p>
              </div>
            </el-popover>
          </div>
          <span class="subscription flex" @click="dialogVisible=true" v-if="concern !== '未登录'"><img
              src="../../assets/img/subscription.png" alt="" width="13">{{ concern }}</span>
          <div class="admire flex" @click="likes">
            <img src="../../assets/img/dz_a.png" alt="" width="27" v-if="admire==0">
            <img src="../../assets/img/dz_b.png" alt="" width="27" v-else>
            <span :class="admire!=0?'classText':''">点赞<span>{{ details.likesCount }}</span></span>
          </div>
        </div>
      </div>

      <loginDialog ref="loginDialog"></loginDialog>
      <!--            <el-dialog-->
      <!--                    width="400px"-->
      <!--                    :visible.sync="needLogin">-->
      <!--                <div slot="title">-->
      <!--                    <i style="color: #e6a23c;font-size: 24px" class="el-icon-warning-outline"></i>-->
      <!--                    <span style="font-size: 20px;display: inline-block;height: 24px;line-height: 24px;vertical-align: 2px;">用户未登录：</span>-->
      <!--                </div>-->
      <!--                <div style="font-size: 14px">-->
      <!--                    <el-link icon="el-icon-s-custom" type="primary" href="/login">已有账号，去登录</el-link>-->
      <!--                    <span>，还没有账号？</span>-->
      <!--                    <el-link icon="el-icon-unlock" type="primary" href="/registered">去注册一个新账号</el-link>-->
      <!--                </div>-->
      <!--            </el-dialog>-->
      <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          class="tips paySuccess"
          top="0"
          :visible.sync="dialogVisible"
          width="400px">
        <img src="../../assets/img/tips.png" alt="" width="140">
        <p>{{ concernMessage }}</p>
        <div class="sub">
          <el-button @click="dialogVisible=false">取消</el-button>
          <el-button v-if="concern==='订阅文章'" @click="addConcern">确定</el-button>
          <el-button v-if="concern==='取消订阅'" @click="delConcern">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';
import loginDialog from "../loginDialog";
import QRCode from "qrcodejs2";

export default {
  name: "newsDetail",
  data() {
    return {
      id: this.$route.query.id,
      name: this.$route.query.name,
      details: {
        publishDate: new Date().Format('yyyy-MM-dd'),
        viewsCount: '99',
      },
      dialogVisible: false,
      admire: 0,
      needLogin: false,
      isLogin: false,
      concernMessage: "",
      concern: "",

      weekHotList: [],
    }
  },
  inject: ['reload'],
  components: {loginDialog},
  async mounted() {
    document.onmousedown = function (e) {
      if (e.button == 2) {
        e.returnValue = false;
      }
    };
    document.addEventListener("copy", function (e) {
      //取消默认事件，才能修改复制的值
      e.preventDefault();
      //复制的内容
      let copyTxt = `${window.location.href}`;
      if (e.clipboardData) {
        e.clipboardData.setData('text/plain', copyTxt);
      } else if (window.clipboardData) {
        return window.clipboardData.setData("text", copyTxt);
      }
    });
    // 加载hot list
    // 数量最大10
    this.$ajax.get(base.api.article.information.weekHot + "?num=5").then(res => {
      if (res.data.status === 'success') {
        this.weekHotList = res.data.list;
      }
    });

    if (this.id) {

      let auth_url = base.api.article.information.details_auth;
      let anyone_url = base.api.article.information.details;
      if (!this.name) {
        auth_url = base.api.article.information.details_auth_intact;
        anyone_url = base.api.article.information.details_name;
        this.name = '***';
      }

      let currentUser = await base.utils.getCurrent();
      if (currentUser) {
        // 登录用户
        this.isLogin = true;
        this.$ajax.get(auth_url.replace("{id}", this.id)).then((res) => {
          if (res.data.status === 'success') {
            this.details = res.data.data;
            if (res.data.data.doctorName) {
              this.name = res.data.data.doctorName;
            }

            // 是否点赞
            this.$ajax.get(base.api.article.information.isLiked.replace("{id}", this.id)).then((res) => {
              if (res.data.status === 'success') {
                this.admire = res.data.data;
              }
            });
            this.getConcern()
          } else {
            this.$router.back();
          }
        }).catch(err => {
          // this.needLogin = true;
          this.getAnyoneDetails(anyone_url);
        });
      } else {
        this.concern = "未登录";
        // this.needLogin = true;
        this.getAnyoneDetails(anyone_url);
      }
      this.initWechatShareQR();
    } else {
      this.$router.back();
    }
  },
  methods: {
    initWechatShareQR(){
      let that = this;
      $('#wechat-share-qr').html('');
      new QRCode('wechat-share-qr', {
        width: 100,
        height: 100,
        text: base.h5_url + '/newsDetails?id=' + that.id,
      });
    },
    getAnyoneDetails(anyone_url) {
      this.$ajax.get(anyone_url.replace("{id}", this.id)).then((res) => {
        if (res.data.status === 'success') {
          this.details = res.data.data;
          if (res.data.data.doctorName) {
            this.name = res.data.data.doctorName;
          }
          if (res.data.data.readAuthority === 0) {
            this.needLogin = false;
          }
        } /*else if (res.data.status === 'needUserLogin') { // 需要登录
          this.needLogin = true;
          this.showLoginDialog();
        }*/ else {
          this.$router.back();
        }
      });
    },
    showLoginDialog() {
      this.$refs.loginDialog.dialogVisible = true;
      this.$refs.loginDialog.reloadCode('vcode-user')
    },
    likes() {
      if (!this.id) {
        return;
      }
      if (!this.isLogin) {
        this.$refs.loginDialog.dialogVisible = true;
        this.$refs.loginDialog.reloadCode('vcode-user');
        return;
      }
      if (this.admire === 0) {
        if (this.id) {
          this.$ajax.post(base.api.article.information.likes.replace("{id}", this.id)).then(() => {
            this.admire = 1;
            this.details.likesCount++;
          }).catch((err) => {
            if (err.response.status === 401) {
              this.showLoginDialog();
              // this.needLogin = true;
            }
          });
        }
      }
    },
    share(code) {
      let url, params;
      if (code === 'qq') {
        url = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?";
        params = {
          url: location.href,
          title: this.details.title,
          desc: "",
          summary: this.details.summary.substr(0, 50) + "...",
          site: '{{200*100}}',
          pics: this.details.thumbnailPath
        };
      } else if (code === 'wb') {
        url = "http://service.weibo.com/share/share.php?";
        params = {
          url: location.href,
          title: this.details.title,
          pic: this.details.thumbnailPath
        };
      }
      window.open(url + $.param(params), '_blank')
    },
    trueSubscription() {
      this.dialogVisible = false

      this.$message({
        message: "订阅成功！",
        type: "success"
      })
    },
    getConcern() {
      let that = this;
      this.$ajax
          .get(base.api.article.concern.get.replace("{type}", 1))
          .then(function (res) {
            if (res.data.status === 'success') {
              if (res.data.data) {
                that.concernMessage = '是否确定取消订阅文章？';
                that.concern = "取消订阅";
              } else {
                that.concernMessage = '是否确定订阅文章？';
                that.concern = "订阅文章";
              }
            }
          })
    },
    addConcern() {
      this.dialogVisible = false
      let that = this;
      this.$ajax.post(base.api.article.concern.add.replace("{type}", 1))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.$message({
                message: '关注成功',
                type: 'success'
              })
            } else {
              that.$message({
                message: '关注失败',
                type: 'warning'
              })
            }
            that.getConcern()
          })
    },
    delConcern() {
      this.dialogVisible = false
      let that = this;
      this.$ajax.delete(base.api.article.concern.delete.replace("{type}", 1))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.$message("取消关注了")
            } else {
              that.$message({
                message: '取消关注失败',
                type: 'warning'
              })
            }
            that.getConcern()
          })
    },
    toDetails(id) {
      this.$router.push({path: '/newsDetail', query: {state: '1', id: id}});
      this.reload();
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/news.scss';

.ban-cp {
  moz-user-select: -moz-none;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;

  ::v-deep img {
    width: 100%;
  }
}

.infoCon {
  .readingTime {
    width: 100%;
  }
}


</style>
<style lang="css">
#wechat-share-qr img{ width: 100%;}
</style>
